import { render, staticRenderFns } from "./AddCoach.vue?vue&type=template&id=14d95833&scoped=true&"
import script from "./AddCoach.vue?vue&type=script&lang=js&"
export * from "./AddCoach.vue?vue&type=script&lang=js&"
import style0 from "./AddCoach.vue?vue&type=style&index=0&id=14d95833&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d95833",
  null
  
)

export default component.exports